import React, { useState, useEffect, useRef } from 'react';
import './GiftBox.css';

const GiftBox = ({ onOpen }) => {
  const [isOpening, setIsOpening] = useState(false);
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [isBirthday, setIsBirthday] = useState(false);
  const audioRef = useRef(null);

  // --- SET BIRTHDAY DATE HERE ---
  // Change this to a past date (e.g., '2024-01-01') to test the Gift Box immediately!
  const birthdayDate = new Date('January 17, 2026 16:47:00').getTime();

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = birthdayDate - now;

      if (distance < 0) {
        setIsBirthday(true);
        clearInterval(timer);
      } else {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000),
        });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [birthdayDate]);

  const handleClick = () => {
    if (!isBirthday) return; 
    setIsOpening(true);
    
    // Play voice note from public/voice-note.mp3
    if (audioRef.current) {
      audioRef.current.play().catch(err => console.log("Audio error:", err));
    }

    setTimeout(() => {
      onOpen();
    }, 3500); // 3.5 seconds to allow animation and voice intro
  };

  return (
    <div className={`gift-overlay ${isOpening ? 'fade-out' : ''}`}>
      <audio ref={audioRef} src="/voice-note.mp3" />

      <div className="gift-container" onClick={handleClick}>
        
        {!isBirthday ? (
          /* --- COUNTDOWN VIEW (Before June 4) --- */
          <div className="countdown-section">
            <h1 className="countdown-title">The Surprise Awaits...</h1>
            <div className="timer">
              <div className="time-block pulse"><span>{timeLeft.days}</span>d</div>
              <div className="time-block pulse"><span>{timeLeft.hours}</span>h</div>
              <div className="time-block pulse"><span>{timeLeft.minutes}</span>m</div>
              <div className="time-block pulse"><span>{timeLeft.seconds}</span>s</div>
            </div>
            <p className="countdown-note">See you on June 4th, Koralie! ❤️</p>
          </div>
        ) : (
          /* --- GIFT BOX VIEW (Unlocked) --- */
          <>
            <div className={`gift-box ${isOpening ? 'open' : ''}`}>
              <div className="gift-lid"><div className="gift-bow"></div></div>
              <div className="gift-body"></div>
            </div>
            <div className={`click-text ${isOpening ? 'hide-text' : ''}`}>
              <h1>Happy Birthday, Koralie!</h1>
              <p>(Tap to Unwrap 🔊)</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default GiftBox;